import classNames from "classnames/bind";
import styles from "./brand-line.module.scss";
import { OwnBrand } from "../../utils/product/getOwnBrand";

const cx = classNames.bind(styles);

type Props = {
  /**
   * An object representing the own brand.
   */
  ownBrand: OwnBrand;
};

export function BrandLineUI({ ownBrand }: Props) {
  if (!ownBrand) return null;

  const isAnyday =
    ownBrand === "jl_own_brand_anyday" ||
    ownBrand === "jl_own_brand_anyday_legacy";

  const isJohnLewis =
    ownBrand === "jl_own_brand_john_lewis" ||
    ownBrand === "jl_own_brand_john_lewis_legacy";

  return (
    <div
      data-testid="brand-line"
      className={cx(styles.line, {
        "line--anyday": isAnyday,
        "line--jl": isJohnLewis,
      })}
    ></div>
  );
}
